// Which EZ Pace this build is for. The on-property installer builds the apps
// with REACT_APP_EDITION=onprem: no sign-up, and a product key (License page)
// instead of Stripe billing. Everything else is the same program.
export const ONPREM = process.env.REACT_APP_EDITION === 'onprem';
